// frontend/src/components/Auth/Registration/AvatarSelection.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../../api/client';
import './AvatarSelection.css';

const AvatarSelection = () => {
    const navigate = useNavigate();
    const [selectedGender, setSelectedGender] = useState('');
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showAvatars, setShowAvatars] = useState(false);
    const [error, setError] = useState('');

    const maleAvatars = [
        { id: 'male_1', emoji: '👨‍💼', name: 'Professional' },
        { id: 'male_2', emoji: '👨‍🎓', name: 'Student' },
        { id: 'male_3', emoji: '👨‍💻', name: 'Techie' },
        { id: 'male_4', emoji: '👨‍🔬', name: 'Scientist' },
        { id: 'male_5', emoji: '👨‍🎨', name: 'Creative' },
        { id: 'male_6', emoji: '👨‍🚀', name: 'Astronaut' },
        { id: 'male_7', emoji: '🧑‍🏫', name: 'Teacher' },
        { id: 'male_8', emoji: '👨‍⚕️', name: 'Doctor' },
        { id: 'male_9', emoji: '👨‍🎤', name: 'Rockstar' },
        { id: 'male_10', emoji: '👨‍🏭', name: 'Engineer' },
        { id: 'male_11', emoji: '🧔', name: 'Cool Guy' },
        { id: 'male_12', emoji: '👨‍🦱', name: 'Curly' },
        { id: 'male_13', emoji: '👨‍🦰', name: 'Ginger' },
        { id: 'male_14', emoji: '🧑‍🚒', name: 'Hero' },
        { id: 'male_15', emoji: '👨‍✈️', name: 'Pilot' }
    ];

    const femaleAvatars = [
        { id: 'female_1', emoji: '👩‍💼', name: 'Professional' },
        { id: 'female_2', emoji: '👩‍🎓', name: 'Student' },
        { id: 'female_3', emoji: '👩‍💻', name: 'Techie' },
        { id: 'female_4', emoji: '👩‍🔬', name: 'Scientist' },
        { id: 'female_5', emoji: '👩‍🎨', name: 'Creative' },
        { id: 'female_6', emoji: '👩‍🚀', name: 'Astronaut' },
        { id: 'female_7', emoji: '👩‍🏫', name: 'Teacher' },
        { id: 'female_8', emoji: '👩‍⚕️', name: 'Doctor' },
        { id: 'female_9', emoji: '👩‍🎤', name: 'Rockstar' },
        { id: 'female_10', emoji: '👩‍🏭', name: 'Engineer' },
        { id: 'female_11', emoji: '👩', name: 'Classic' },
        { id: 'female_12', emoji: '👩‍🦱', name: 'Curly' },
        { id: 'female_13', emoji: '👩‍🦰', name: 'Ginger' },
        { id: 'female_14', emoji: '🧑‍🚒', name: 'Hero' },
        { id: 'female_15', emoji: '👩‍✈️', name: 'Pilot' }
    ];

    const handleGenderSelect = (gender) => {
        setSelectedGender(gender);
        setShowAvatars(true);
        setSelectedAvatar(null);
        setError('');
        triggerGenderSelectAnimation();
    };

    const handleAvatarSelect = (avatar) => {
        setSelectedAvatar(avatar);
        setError('');
    };

    const triggerGenderSelectAnimation = () => {
        const card = document.querySelector('.avatar-card-gamified');
        if (card) {
            card.classList.add('gender-flash');
            setTimeout(() => card.classList.remove('gender-flash'), 300);
        }
    };

    const triggerShake = () => {
        const card = document.querySelector('.avatar-card-gamified');
        if (card) {
            card.classList.add('game-shake');
            setTimeout(() => card.classList.remove('game-shake'), 400);
        }
    };

    const handleSaveAvatar = async () => {
        if (!selectedGender) {
            setError('⚔️ Please select your gender first! ⚔️');
            triggerShake();
            return;
        }

        if (!selectedAvatar) {
            setError('🎭 Please choose your hero avatar! 🎭');
            triggerShake();
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await authAPI.saveAvatar({
                gender: selectedGender,
                avatar_id: selectedAvatar.id
            });

            if (response.success) {
                const card = document.querySelector('.avatar-card-gamified');
                if (card) {
                    card.classList.add('victory-glow');
                }
                setTimeout(() => {
                    navigate('/dashboard');
                }, 1000);
            } else {
                setError(response.message || 'Failed to save avatar');
                triggerShake();
            }
        } catch (error) {
            console.error('Error saving avatar:', error);
            setError('💀 Failed to save avatar. Please try again.');
            triggerShake();
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        setShowAvatars(false);
        setSelectedGender('');
        setSelectedAvatar(null);
        setError('');
    };

    const avatars = selectedGender === 'male' ? maleAvatars : femaleAvatars;

    return (
        <div className="avatar-gamified-world">
            {/* Simple floating particles */}
            <div className="particle-bg-avatar">
                {[...Array(20)].map((_, i) => (
                    <div key={i} className="particle-avatar" style={{
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 10}s`,
                        animationDuration: `${8 + Math.random() * 7}s`
                    }}></div>
                ))}
            </div>

            <div className="avatar-container-gamified">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10">
                        <div className="avatar-card-gamified">
                            {/* Header */}
                            <div className="avatar-header-gamified">
                                <div className="game-badge-avatar">
                                    <i className="fas fa-dice-d20"></i>
                                    <span>FINAL QUEST</span>
                                    <i className="fas fa-dice-d6"></i>
                                </div>
                                <div className="header-avatar-gamified">
                                    <span className="avatar-icon-gamified">👤</span>
                                    <span className="final-sparkle">✨</span>
                                </div>
                                <h2>Choose Your Hero</h2>
                                <p>Create your legendary identity</p>
                                <div className="xp-bar-avatar">
                                    <div className="xp-fill-avatar" style={{ width: '100%' }}></div>
                                    <span className="xp-text-avatar">Final Step!</span>
                                </div>
                            </div>

                            {/* Body */}
                            <div className="avatar-body-gamified">
                                {error && (
                                    <div className="game-alert-avatar">
                                        <i className="fas fa-skull me-2"></i>
                                        {error}
                                    </div>
                                )}

                                {!showAvatars ? (
                                    // Gender Selection
                                    <div className="gender-section-gamified">
                                        <div className="quest-title">
                                            <i className="fas fa-flag-checkered"></i>
                                            <h4>First, Choose Your Path</h4>
                                        </div>
                                        <div className="gender-grid-gamified">
                                            <div className="gender-card-gamified" onClick={() => handleGenderSelect('male')}>
                                                <div className="gender-icon-wrapper">
                                                    <i className="fas fa-mars fa-4x"></i>
                                                </div>
                                                <h5>Male Warrior</h5>
                                                <p>Strength & Strategy</p>
                                                <span className="select-hint">⚔️ SELECT ⚔️</span>
                                            </div>
                                            <div className="gender-card-gamified" onClick={() => handleGenderSelect('female')}>
                                                <div className="gender-icon-wrapper">
                                                    <i className="fas fa-venus fa-4x"></i>
                                                </div>
                                                <h5>Female Warrior</h5>
                                                <p>Wisdom & Grace</p>
                                                <span className="select-hint">⚔️ SELECT ⚔️</span>
                                            </div>
                                        </div>

                                        <div className="quest-progress-avatar">
                                            <div className="quest-steps-avatar">
                                                <div className="step-avatar completed">🏫</div>
                                                <div className="step-avatar completed">📧</div>
                                                <div className="step-avatar completed">🔐</div>
                                                <div className="step-avatar active">👤</div>
                                                <div className="step-avatar">✅</div>
                                            </div>
                                            <div className="progress-bar-avatar">
                                                <div className="progress-fill-avatar" style={{ width: '80%' }}></div>
                                            </div>
                                            <p className="progress-text-avatar">Quest Progress: 80%</p>
                                        </div>
                                    </div>
                                ) : (
                                    // Avatar Selection
                                    <>
                                        <div className="avatar-selection-header-gamified">
                                            <div className="header-left">
                                                <i className="fas fa-crown"></i>
                                                <h4>Choose Your Avatar</h4>
                                            </div>
                                            <button className="back-btn-gamified" onClick={handleBack}>
                                                <i className="fas fa-arrow-left"></i> Change Gender
                                            </button>
                                        </div>

                                        <div className="selected-preview-gamified">
                                            <div className="preview-circle-gamified">
                                                <span className="preview-emoji-gamified">
                                                    {selectedAvatar ? selectedAvatar.emoji : '❓'}
                                                </span>
                                                {selectedAvatar && (
                                                    <div className="preview-glow"></div>
                                                )}
                                            </div>
                                            <p className="preview-name">
                                                {selectedAvatar ? `${selectedAvatar.name} Avatar Selected` : 'Select your hero below'}
                                            </p>
                                        </div>

                                        <div className="avatars-grid-gamified">
                                            {avatars.map((avatar) => (
                                                <div
                                                    key={avatar.id}
                                                    className={`avatar-option-gamified ${selectedAvatar?.id === avatar.id ? 'selected-avatar' : ''}`}
                                                    onClick={() => handleAvatarSelect(avatar)}
                                                >
                                                    <span className="avatar-emoji-gamified">{avatar.emoji}</span>
                                                    <span className="avatar-name-gamified">{avatar.name}</span>
                                                    {selectedAvatar?.id === avatar.id && (
                                                        <div className="check-mark">
                                                            <i className="fas fa-check-circle"></i>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        <button
                                            className="confirm-btn-gamified"
                                            onClick={handleSaveAvatar}
                                            disabled={!selectedAvatar || loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-avatar"></span>
                                                    <span>SUMMONING HERO...</span>
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-crown"></i>
                                                    <span>Start Adventure →</span>
                                                    <i className="fas fa-dragon"></i>
                                                </>
                                            )}
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AvatarSelection;